import { render, staticRenderFns } from "./AttendanceSettings.vue?vue&type=template&id=4566ed23"
import script from "./AttendanceSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports